import { debounce } from 'lodash';

// グローバルに設定（Sprockets管理下のファイルから使用可能）
window.debounce = debounce;

export default debounce;
